import React from 'react'
import styles from '../../../css/services/conServices.module.css';
function MadadServices() {
  return (
      <div className={styles.container}>
          <div className={styles.services}>
              <div>
                  <h1>1. التسجيل في منصة مدد (Mudad registration)</h1>
                  <p>
                      خدمة لتسجيل الشركات في منصة مدد للاستفادة من
                      <br/>
                      خدماتها  في مجال إدارة الموارد البشرية
                      والأجور
                  </p>
              </div>
              <div>
                  <h1>2. رفع الرواتب من منصة مدد (Mudad uploading )</h1>
                  <p>
                      إمكانية تقديم الرواتب والمخصصات للموظفين من خلال منصة مدد مما يسهل عملية الإدارة المالية للشركة.
                  </p>
              </div>
              <div>
                  <h1>3. تحديث بيانات الموظفين Updating employee information</h1>
                  <p>
                      خدمة لتحديث معلومات الموظفين في قاعدة بيانات
                      <br/>
                      منصة مدد، مع توفير آليات فعالة لتحديث
                      <br/>
                      المعلومات بشكل دوري
                  </p>
              </div>
              <div>
                  <h1>4. تبرير ملاحظات حماية الأجور Justifying salaries protection notes </h1>
                  <p>
                      خدمة لتوضيح وتبرير أي ملاحظات أو تعديلات تتعلق
                      <br/>
                      بحماية الأجور لضمان التماشي مع القوانين واللوائح
                  </p>
              </div>
          </div>
      </div>
  )
}

export default MadadServices